import React, { useEffect, useRef, useState } from 'react'
import { Button, makeStyles } from '@material-ui/core'

const SAVED_FLASH_MS = 1600

const useStyles = makeStyles({
    button: {
        textTransform: 'none',
        fontWeight: 600,
        minWidth: 72,
    },
})

export type FormSaveAction = {
    dirty: boolean
    saving: boolean
    onSave: () => void
}

/**
 * Explicit form commit: Save → Saving… → Saved, then back to Save.
 */
export const FormSaveButton: React.FC<FormSaveAction> = ({
    dirty,
    saving,
    onSave,
}) => {
    const classes = useStyles()
    const [showSaved, setShowSaved] = useState(false)
    const wasDirty = useRef(dirty)

    useEffect(() => {
        if (saving) {
            setShowSaved(false)
        } else if (wasDirty.current && !dirty) {
            setShowSaved(true)
            const timer = window.setTimeout(
                () => setShowSaved(false),
                SAVED_FLASH_MS,
            )
            wasDirty.current = dirty
            return () => window.clearTimeout(timer)
        }
        if (dirty) {
            setShowSaved(false)
        }
        wasDirty.current = dirty
    }, [dirty, saving])

    const label = saving ? 'Saving…' : showSaved ? 'Saved' : 'Save'

    return (
        <Button
            className={classes.button}
            color="primary"
            variant="contained"
            size="small"
            disableElevation
            disabled={saving || (!dirty && !showSaved)}
            onClick={onSave}
        >
            {label}
        </Button>
    )
}
